<template>
	<div>
		<div id="Waves">
			<!-- Header -->
			<div class="header py-7 py-lg-8 pt-lg-9">
				<b-container>
					<div class="header-body text-center mb-7">
						<b-row class="justify-content-center">
							<b-col xl="6" lg="6" md="8" class="px-5">
								<h1 id="welcome" class="text-white">Welcome to the {{ client }} Provisioning Portal</h1>
								<p class="text-lead text-white">Sign in to start your session.</p>
							</b-col>
						</b-row>
					</div>
				</b-container>
			</div>

			<!-- Page content -->
			<b-container class="mt--8 pb-5 login-box">
				<b-row v-if="!loginValue" class="justify-content-center">
					<b-col lg="6" md="7">
						<b-card no-body class="bg-secondary border-0 mb-0">
							<b-card-header class="bg-transparent pb-5 justify-content-center"
								><h4>Authenticating</h4></b-card-header
							>
							<b-card-body class="px-lg-5 py-lg-5 justify-content-center text-center">
								<div class="text-center w-100 mb-4">
									<b-icon
										icon="three-dots"
										class="text-center"
										animation="cylon"
										font-scale="4"
									></b-icon>
								</div>
								<p class="justify-content-center">Please wait while we validate your credentials.</p>
							</b-card-body>
						</b-card>
					</b-col>
				</b-row>

				<b-row class="justify-content-center" v-if="loginValue">
					<b-col lg="6" md="7">
						<b-card no-body class="bg-secondary border-0 mb-0">
							<b-card-header class="bg-transparent pb-5" style="display: none">
								<div class="text-muted text-center mt-2 mb-3">
									<small>Sign in with</small>
								</div>
								<div class="btn-wrapper text-center">
									<a href="#" class="btn btn-neutral btn-icon">
										<span class="btn-inner--icon"><img src="img/icons/common/github.svg" /></span>
										<span class="btn-inner--text">Github</span>
									</a>
									<a href="#" class="btn btn-neutral btn-icon">
										<span class="btn-inner--icon"><img src="img/icons/common/google.svg" /></span>
										<span class="btn-inner--text">Google</span>
									</a>
								</div>
							</b-card-header>

							<b-card-body class="px-lg-5 py-lg-5">
								<div class="text-center text-muted mb-4">
									<img :alt="`${customer} logo`" :style="logoStyle" v-bind:src="pageLogo" /><br />
									<small>Sign in with your assigned credentials</small>
								</div>
								<validation-observer v-slot="{handleSubmit}" ref="formValidator">
									<b-form role="form" @submit.prevent="handleSubmit(authenticateUser)">
										<b-input-group class="mb-4">
											<b-input-group-prepend>
												<b-button
													:variant="validationUsername ? 'outline-success' : 'outline-danger'"
												>
													<i class="fa fa-user"></i>
												</b-button>
											</b-input-group-prepend>
											<b-form-input
												id="username"
												data-cy="username"
												v-model="loginForm.username"
												:state="validationUsername"
												placeholder="Input Username"
												aria-describedby="username-feedback"
											></b-form-input>
											<b-form-invalid-feedback id="username-feedback" :state="validationUsername">
												Input valid username
											</b-form-invalid-feedback>
										</b-input-group>

										<b-input-group class="mb-4">
											<b-input-group-prepend>
												<b-button
													:variant="validationPassword ? 'outline-success' : 'outline-danger'"
												>
													<i class="fas fa-key"></i>
												</b-button>
											</b-input-group-prepend>
											<b-form-input
												id="input-valid"
												data-cy="password"
												type="password"
												v-model="loginForm.password"
												:state="validationPassword"
												placeholder="Input Password"
												aria-describedby="password-feedback"
											></b-form-input>
											<b-form-invalid-feedback id="password-feedback" :state="validationPassword">
												Input valid password
												<router-link to="/forgot" class="text-light" custom v-slot="{navigate}">
													<a @keypress.enter="navigate" @click="navigate" role="link">
														<label
															for="password"
															class="text-sm text-primary cursor-pointer"
														>
															<small> Forgot Password?</small>
														</label>
													</a>
												</router-link>
											</b-form-invalid-feedback>
										</b-input-group>

										<div class="text-center w-100">
											<base-button type="primary" native-type="submit" class="my-4 w-100"
												>Sign in
											</base-button>
										</div>
									</b-form>
								</validation-observer>
								<div class="text-center">
									<router-link
										to="/register"
										class="text-light"
										v-if="registerStatus > 0"
										custom
										v-slot="{navigate}"
									>
										<a @keypress.enter="navigate" @click="navigate" role="link">
											<small>Create new account</small></a
										>
									</router-link>
								</div>
							</b-card-body>
						</b-card>
					</b-col>
				</b-row>
			</b-container>
		</div>
	</div>
</template>

<script>
import {mapState} from "vuex";
import initService from "@/common/api-services/init-service";
import sessionIdDirective from "@/common/directive/sessionId-directive";
import configDirective from "@/common/directive/config-directive";
import commonService from "@/common/api-services/common";
import authService from "@/common/api-services/auth-service";
import LogRocket from "logrocket";

export default {
	name: "login",
	data() {
		return {
			loginForm: {
				username: "",
				password: "",
			},
			client: process.env.PORTAL_NAME,
			errorMessage: "",
			loginValue: true,
			registerStatus: 0,
			pageLogo: "",
			logoStyle: "",
			customer: process.env.VUE_APP_CLIENT.toString().toLowerCase(),
		};
	},
	mounted() {
		let width = `137px`;
		this.logoStyle = `width: ${width}; `;
		this.pageLogo = "/img/brand/" + process.env.VUE_APP_CLIENT.toString().toLowerCase() + ".png";
		//is user authenticated
		if (this.isAuthenticated) {
			//goto dashboard
			this.$router.push({name: "dashboard"});
		} else {
			//cleanup local storage
			sessionStorage.clear();
			localStorage.clear();

			//register user
			//initService.clearCache();

			//reload the config
			//initService.getConfig();

			let registerUser = configDirective.getRegisterStatus();
			if (!registerUser) {
				this.registerStatus = 0;
			} else if (registerUser < 1) {
				this.registerStatus = 0;
			} else if (registerUser > 0) {
				this.registerStatus = 1;
			}
		}

		//always set session and render background.
		sessionIdDirective.setSessionId();
		this.$root.$emit("renderBackground", true);
	},
	methods: {
		authenticateUser() {
			if (this.validationUsername && this.validationPassword) {
				this.loginValue = false;
				const username = this.loginForm.username;
				const password = this.loginForm.password;
				let credential = btoa(username + "|" + password);

				authService
					.getLogin(credential, username)
					.then(res => {
						//debugger;
						//console.log(res);

						if (JSON.stringify(res).includes("FAIL")) {
							this.$toast.error("Invalid username or password");
						}

						if (res.data.message["ChallengeName"] === "NEW_PASSWORD_REQUIRED") {
							authService.setActivityLog(
								"AUTH:Login",
								JSON.stringify(res.data.message["ChallengeName"]),
								1
							);
							commonService.showToast("Please contact DCC to setup your account.", "Login Error");
						}

						//if (res.data.message["ChallengeName"] == "SMS_MFA") {

						let grp = res.data.message["groups"];
						let accessToken = res.data.message["access_token"];
						if (grp && grp.length > 0) {
							//TODO: why session and current user on local storage... why not all session?
							sessionStorage.setItem("accessToken", accessToken);

							sessionStorage.setItem("IOT_GetCurrentUser", JSON.stringify(res.data.message));
							authService.setActivityLog(
								"AUTH:Login",
								"Login [" + JSON.stringify(configDirective.getCurrentUser()) + "] OK",
								0
							);

							//set default open cards
							initService.resetOpenCards();

							//fix the default route in the Event that Home is missing.
							let redirectPath = "default_home";

							let navigation = configDirective.getNavigation();
							if (JSON.stringify(navigation).includes("DYNAMIC")) {
								this.getHomeLink().then(response => {
									if (response) {
										redirectPath = response;
									}
								});
							} else if (JSON.stringify(navigation).includes("HOME_DEFAULT")) {
								redirectPath = "default_home";
							} else {
								redirectPath = "home";
							}

							setTimeout(() => {
								this.$router.replace({path: `${redirectPath}`});
							}, 400);

							// setTimeout(() => {
							// 	this.$root.$emit("stopBackgroundAnimation", true);
							// }, 400);

							this.errorMessage = "";
						} else {
							this.loginValue = true;
							// We need to improve upon the login responses.  see: AWSCognitoWrapper.js line 172
							//console.log('debugging login: ', res.data);
							if (res.data.message.indexOf("FAIL") !== -1) {
								throw new Error("Invalid username or password.");
							}
							//authService.setActivityLog("AUTH:Login", "Login OK", 0);
							authService.setActivityLog(
								"AUTH:Login",
								"Login [" + JSON.stringify(configDirective.getCurrentUser()) + "] OK",
								0
							);

							//this.$store.dispatch("getMenuLinks");
							//this.getHomeLink();
						}
						// Add LogRocket identify here
						// console.log('LogRocket identify: ', configDirective.getCurrentUser().username);
						LogRocket.identify(configDirective.getCurrentUser().username);
					})
					.catch(err => {
						authService.setActivityLog("AUTH:Login", JSON.stringify(err), 1);
						sessionStorage.removeItem("accessToken");
						sessionStorage.removeItem("IOT_GetCurrentUser"); // if the request fails, remove any possible user token if possible
						this.errorMessage = err.toString().replace("Error:", "");
						this.loginValue = true;
					});
			}
		},
		async getHomeLink() {
			let homeLink = "";
			let links = [];
			let groups = JSON.parse(JSON.stringify(initService.getGroups()).toUpperCase());
			// console.log('groups:', groups)
			await authService
				.getMenuLinks("All")
				.then(response => {
					// console.log('admin:', response.message)
					if (!response.message || response.message.hasOwnProperty("error")) {
						if (!response.message) {
							throw new Error(response);
						} else {
							throw new Error(response.message.error);
						}
					} else {
						response.message.results &&
							response.message.results.map(item => {
								groups.map(role => {
									if (item.roles.toUpperCase().includes(role) && !links.includes(item)) {
										links.push(item);
									}
								});
								if (item.group === "Home Group" && item.link.includes("home")) {
									homeLink = item.link;
								}
							});
						this.$store.commit("setLinks", links);
					}
				})
				.catch(error => {
					console.error(error);
					if (error.message) {
						this.$toast.error(error.message, {
							title: "Error",
							description: error.message,
						});
					}
				});

			return homeLink;
		},
	},
	computed: {
		...mapState(["isAuthenticated"]),
		validationUsername() {
			return this.loginForm.username.length > 0 && !this.loginForm.username.includes(" ");
		},
		validationPassword() {
			return !!(this.loginForm && this.passwordUppercase && this.passwordNumber && this.passwordCharacter);
		},
		passwordLength() {
			return this.loginForm.password.length > 7;
		},
		passwordUppercase() {
			let pass = this.loginForm.password;
			for (let i = 0; i < pass.length; i++) {
				if ("A" <= pass[i] && pass[i] <= "Z") {
					return true;
				}
			}
		},
		passwordNumber() {
			let pass = this.loginForm.password;
			for (let i = 0; i < pass.length; i++) {
				if ("0" <= pass[i] && pass[i] <= "9") {
					return true;
				}
			}
		},
		passwordCharacter() {
			let format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
			if (format.test(this.loginForm.password)) {
				return true;
			}
		},
	},
};
</script>
